import React from 'react';
import { getModuleComponent } from './modules';

interface ModuleProps {
    moduleType: string;
    moduleContext: object;
    env: any;
    user: any;
}

const Module = ({ moduleType, moduleContext, env, user }: ModuleProps) => {
    const ModuleComponent = getModuleComponent(moduleType);
    return <ModuleComponent env={env} user={user} {...moduleContext} />;
};

// The Module interface matches the schema for a module in Wagtail's API.
// A Wagtail module is serialized as:
// {
//     type: string (e.g. 'raw_html_content')
//     value: object (e.g. {'raw_html_block': '<div>hello world</div>'})
//     id: string (e.g. '76f18e00-dc22-4a0d-9280-25aefe98b005')
// }
export interface ModuleInterface {
    type: string;
    value: object;
    id: string;
}

export interface ModuleListProps {
    modules: Array<ModuleInterface>;
    env?: any;
    user?: any;
}

class ModuleList extends React.PureComponent<ModuleListProps> {
    render() {
        const { modules, env, user } = this.props;

        return (
            <div>
                {modules.map(({ type, value }, idx) => (
                    <Module
                        key={idx}
                        moduleType={type}
                        moduleContext={value}
                        env={env}
                        user={user}
                    />
                ))}
            </div>
        );
    }
}

export default ModuleList;
